// @ts-nocheck
import { MFASettingsCaller } from '../Codes';
import RestService from './Services/RestService';
import { SignupErrorCode } from './sign-up-errors';
import {
    ErrorType,
    ErrorMessages,
    GetErrorTypeByCode,
    ClearErrorMessages,
    ContainerHasNoError,
    CreateErrorMessageHTML,
    FocusOnFirstInputWithError,
} from './sign-up-errors';
import Validator from './sign-up-validator';

(function () {
    const signUpForm = document.getElementById('SignupForm');
    const loadingSpinner = document.getElementById('LoadingSpinner');
    const signupButton = document.getElementById('SignupButton');
    let isFirstSubmit = true;
    let isFormSubmitting = false;
    let isWaitingForTurnstileToken = false;
    let turnstileTimeoutId: any = null;

    const addInputListenerToAllRequiredFields = () => {
        const requiredFields = Array.from(signUpForm.querySelectorAll('[required]'));
        requiredFields.forEach((field) => {
            field.addEventListener('input', function () {
                Validator.CheckRequiredField(field);
            });
        });
    };

    const handleError = (errorCodes: string[]) => {
        const errorContainer = document.getElementById('GeneralError');
        ClearErrorMessages(errorContainer);

        if (errorCodes) {
            errorCodes.forEach((errorCode) => {
                const errorType = GetErrorTypeByCode(errorCode);
                const message = ErrorMessages[errorCode] || ErrorMessages[SignupErrorCode.GeneralError];

                if (errorType && errorType === ErrorType.Email) {
                    const emailAddress = document.querySelector('input[name=Email]');
                    emailAddress.closest('.signup-form-field').appendChild(message && CreateErrorMessageHTML(message));
                } else {
                    //Treat all others as general error
                    errorContainer.appendChild(message && CreateErrorMessageHTML(message));
                    errorContainer.classList.add('show');
                    errorContainer.focus();
                }
            });
        } else {
            const message = ErrorMessages[SignupErrorCode.GeneralError];
            errorContainer.appendChild(message && CreateErrorMessageHTML(message));
            errorContainer.classList.add('show');
            errorContainer.focus();
        }
        FocusOnFirstInputWithError();
    };

    const hideGeneralError = () => {
        const errorContainer = document.getElementById('GeneralError');
        errorContainer.classList.remove('show');
    };

    const showLoadingSpinner = () => {
        signupButton.classList.add('submitted');
        loadingSpinner.classList.remove('hide');
        loadingSpinner.classList.add('show');
    };

    const hideLoadingSpinner = () => {
        signupButton.classList.remove('submitted');
        loadingSpinner.classList.remove('show');
        loadingSpinner.classList.add('hide');
    };

    const resetTurnstile = () => {
        if (window.turnstile?.reset) {
            try {
                window.turnstile.reset();
            } catch (e) {
                // ignore
            }
        }
    };

    const trimWhiteSpaceAndUpdateFields = () => {
        const firstNameField = document.querySelector('input[name=FirstName]');
        const lastNameField = document.querySelector('input[name=LastName]');
        const practiceNameField = document.querySelector('input[name=PracticeName]');
        const mobilePhoneField = document.querySelector('input[name=ContactNumber]');
        const emailAddressField = document.querySelector('input[name=Email]');

        firstNameField.value = firstNameField.value.trim();
        lastNameField.value = lastNameField.value.trim();
        practiceNameField.value = practiceNameField.value.trim();
        mobilePhoneField.value = mobilePhoneField.value.trim();

        // Querying the value property for email input already returns trimmed string. The display does not get updated if value is assigned to the same value.
        // As a workaround, setAttribute() is called here to change the displayed value.
        emailAddressField.value = emailAddressField.value.trim();
        emailAddressField.setAttribute('value', emailAddressField.value.trim());
    };

    const signup = (turnstileToken: string) => {
        if (turnstileTimeoutId) {
            clearTimeout(turnstileTimeoutId);
            turnstileTimeoutId = null;
        }
        const firstName = document.querySelector('input[name=FirstName]').value;
        const lastName = document.querySelector('input[name=LastName]').value;
        const practiceName = document.querySelector('input[name=PracticeName]').value;
        const mobilePhone = document.querySelector('input[name=ContactNumber]').value;
        const emailAddress = document.querySelector('input[name=Email]').value;
        const password = document.querySelector('input[name=Password]').value;
        const country = document.querySelector('select[name=Country]').value;
        const acceptTerms = document.querySelector('input[name=AcceptTerms]').checked;
        const trialProfile = document.querySelector('input[name="subscription-plan"]:checked').id;
        const planCode = document.getElementById('planCode').value;
        const __RequestVerificationToken = document.querySelector('input[name="__RequestVerificationToken"]').value;

        const postData = {
            firstName: firstName,
            lastName: lastName,
            practiceName: practiceName,
            mobilePhone: mobilePhone,
            emailAddress: emailAddress,
            password: password,
            countryCode: country,
            acceptTerms: acceptTerms,
            trialProfile: trialProfile,
            planCode: planCode,
            __RequestVerificationToken: __RequestVerificationToken,
            turnstileToken: turnstileToken,
        };

        RestService.Signup(
            postData,
            (response) => {
                if (response.Success) {
                    window.location.assign(`/member/MFASettings?caller=${MFASettingsCaller.SignUp}`);
                } else {
                    handleError(response.ErrorMessages);
                    resetTurnstile();
                }

                isFormSubmitting = false;
                response.Success ? setTimeout(hideLoadingSpinner, 2000) : hideLoadingSpinner();
            },
            (error) => {
                handleError([SignupErrorCode.GeneralError]);
                resetTurnstile();

                isFormSubmitting = false;
                hideLoadingSpinner();
            },
        );
    };

    const executeTurnstile = () => {
        if (!window.turnstile?.execute) {
            console.warn('Turnstile SDK is missing or non-functional. Proceeding with empty token.');
            signup('');
            return;
        }

        isWaitingForTurnstileToken = true;

        turnstileTimeoutId = setTimeout(() => {
            if (isWaitingForTurnstileToken) {
                console.warn('Turnstile execution timed out. Proceeding with empty token.');
                isWaitingForTurnstileToken = false;
                signup('');
            }
        }, 4000);

        try {
            window.turnstile.execute();
        } catch (error) {
            console.warn('Turnstile execute failed:', error);
            isWaitingForTurnstileToken = false;
            signup('');
        }
    };

    window.onTurnstileSuccess = function (token: string) {
        if (!isWaitingForTurnstileToken || !isFormSubmitting) {
            return;
        }

        isWaitingForTurnstileToken = false;
        signup(token);
    };

    window.onTurnstileError = function (errorCode: string) {
        console.warn('CAPTCHA frontend verification failed. ErrorCode:' + errorCode);

        if (!isWaitingForTurnstileToken || !isFormSubmitting) {
            return;
        }

        isWaitingForTurnstileToken = false;
        resetTurnstile();
        signup('');
    };

    window.onTurnstileExpired = function () {
        resetTurnstile();
    };

    const validate = () => {
        hideGeneralError();
        Validator.CheckAll();

        const isValid = ContainerHasNoError(signUpForm) || FocusOnFirstInputWithError();
        return isValid;
    };

    const addValidationOnInputEvents = () => {
        addInputListenerToAllRequiredFields();

        const company = document.querySelector('input[name=PracticeName]');
        company.addEventListener('input', function () {
            Validator.CheckCompanyName();
        });

        const email = signUpForm.querySelector('input[name=Email]');
        email.addEventListener('input', function () {
            Validator.CheckEmail();
        });

        const password = signUpForm.querySelector('input[name=Password]');
        password.addEventListener('input', function () {
            Validator.CheckPassword();
        });

        const acceptTerms = signUpForm.querySelector('input[name="AcceptTerms"]');
        acceptTerms.addEventListener('click', function () {
            Validator.CheckAcceptTerms();
        });
    };

    const preSelectTrialPlan = () => {
        const trialProfile = document.getElementById('TrialPlan').value;
        const trialPlanCollection = signUpForm.elements['subscription-plan'];
        const trialPlans = trialPlanCollection ? Array.from(trialPlanCollection) : [];

        const plan = trialPlans.find((plan) => plan.id === trialProfile);

        if (plan) {
            plan.closest('.signup-form-field').classList.add('hidden');
            plan.checked = true;
        }
    };

    signUpForm.addEventListener('submit', function (evt) {
        evt.preventDefault();

        trimWhiteSpaceAndUpdateFields();

        if (isFirstSubmit) {
            addValidationOnInputEvents();
            isFirstSubmit = false;
        }

        if (isFormSubmitting) return true;

        if (validate()) {
            isFormSubmitting = true;
            showLoadingSpinner();
            executeTurnstile();
        }
    });

    preSelectTrialPlan();
})();
